import { Toast, ToastrService, ToastPackage, ToastrModule } from 'ngx-toastr';
import { MyHttpInterceptorService } from './my-http-interceptor.service';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserServiceService } from './user-service.service';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from './login/login.component';
import { AlertService } from './alert.service';
import { BuyerComponent } from './buyer/buyer.component';
import { PostComponent } from './post/post.component';
import { CityComponent } from './city/city.component';
import { PlaceComponent } from './place/place.component';
import { ReviewComponent } from './review/review.component';
import { ImageStoreComponent } from './image-store/image-store.component';
import { UsersCompComponent } from './users-comp/users-comp.component';
import { AdsComponent } from './ads/ads.component';
import { PaymentCompComponent } from './payment-comp/payment-comp.component';


@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    ReactiveFormsModule,
    CommonModule,
    NgbModule.forRoot(),
    ToastrModule.forRoot()
  ],
  exports :[
    HttpClientModule
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    LoginComponent,
    //PaymentCompComponent,
    //AdsComponent,
    //UsersCompComponent,
     ],
  providers: [ UserServiceService,
    { provide: HTTP_INTERCEPTORS, useClass: MyHttpInterceptorService, multi: true },
    MyHttpInterceptorService,
    AlertService,

    ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts